export default "__VITE_ASSET__RG9qZq6e__"